import { QueryClientProvider } from '@tanstack/react-query'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@/styles/global.css'

import { queryClient } from '@/lib/query-client'
import { iniciarTema } from '@/lib/tema'

import { Toaster } from '@/components/ui/toast'
import { TooltipProvider } from '@/components/ui/tooltip'

import { routeTree } from '@/routeTree.gen'

// Como o painel antigo, barras no fim do endereço são ignoradas
// (ex.: `/violacoes/` abre `/violacoes`). Maiúsculas continuam valendo.
const semBarraFinal = window.location.pathname.replace(/\/+$/, '')
if (semBarraFinal && semBarraFinal !== window.location.pathname) {
  window.history.replaceState(
    window.history.state,
    '',
    `${semBarraFinal}${window.location.search}${window.location.hash}`
  )
}

iniciarTema()

const router = createRouter({ routeTree, context: { queryClient } })

// Torna as rotas type-safe em toda a aplicação.
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const container = document.getElementById('root')
if (!container) {
  throw new Error('Elemento #root não encontrado no index.html')
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Avisos rápidos (toasts) e dicas das telas novas valem para o app inteiro. */}
      <TooltipProvider>
        <Toaster position="bottom-right" timeout={5000}>
          <RouterProvider router={router} />
        </Toaster>
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>
)
